export default "__VITE_ASSET__CNR2A3ox__"